import React from 'react';
import SetUpProject from '../Onboarding/SetUpProject/SetUpProject';
import styles from './CreateProject.module.css';

// Standalone page for creating a new project. Previously "step 1" of the
// Onboarding stepper — now its own route (/create-project), reachable both
// by brand-new users (zero projects) and by existing users adding another
// project from the TopNav switcher's "+ Create new project" entry.
//
// Multi-Platform Business Support TRD (Bounded Unit B, Requirement B2): this
// step now renders the project-type selector (Shopify / Other) plus name +
// invite-teammates fields, and creates the project immediately on submit via
// POST /project — the Shopify store URL is no longer collected here (moved
// to the Step 2 grant-access dialog, Requirement B3).
const CreateProject = ({ onProjectCreated }) => {
  return (
    <div className={styles.pageShell}>
      <div className={styles.contentInner}>
        <SetUpProject onProjectCreated={onProjectCreated} />
      </div>
    </div>
  );
};

export default CreateProject;
